import { useAuth } from "@/shared/auth/fetch/useAuth";
import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_requeired/")({
  component: () => {
    const auth = useAuth();
    console.log("[routes._auth_required.index] auth", auth);
    const navigate = useNavigate();
    if (!auth.session.isAuthenticated) {
      console.log("[routes._auth_required.index] not authenticated");
      navigate({
        to: "/login",
      });
      return null;
    }
  },
});
